import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IOnboardingStatusDto } from '@reservaties/api-interfaces';
import { BehaviorSubject, Observable, tap } from 'rxjs';

/** Holds the tenant's onboarding/setup status for the admin shell, checklist
 * and editor warnings. Refresh after actions that change it (production save,
 * Stripe return). Aliases: onboarding status, setup guide state. */
@Injectable({ providedIn: 'root' })
export class OnboardingService {
  private readonly statusSubject =
    new BehaviorSubject<IOnboardingStatusDto | null>(null);
  readonly status$ = this.statusSubject.asObservable();

  constructor(private http: HttpClient) {}

  refresh(): Observable<IOnboardingStatusDto> {
    return this.http
      .get<IOnboardingStatusDto>('/api/account/onboarding-status')
      .pipe(tap((status) => this.statusSubject.next(status)));
  }

  dismiss(): Observable<void> {
    return this.http.post<void>('/api/account/onboarding-dismiss', {}).pipe(
      tap(() => {
        const current = this.statusSubject.value;
        if (current) {
          this.statusSubject.next({ ...current, dismissed: true });
        }
      })
    );
  }

  /** Clear cached status when switching tenants. */
  reset(): void {
    this.statusSubject.next(null);
  }
}
